/**
 * Footer behaviours — currently just "back to top".
 *
 * This started life as a `{% javascript %}` block delegating from `document`. That code
 * shipped and was reachable, but delegation from the document is the fragile way to do it:
 * any ancestor that stops propagation kills it silently, and inside the theme editor the
 * host frame handles link clicks of its own. Binding straight to the element removes that
 * whole class of problem, and it matches how every other eb-* section loads its script.
 *
 * The markup points at #MainContent, so with JavaScript disabled the link still jumps to
 * the top of the page. This only upgrades the jump to a smooth scroll.
 */
(() => {
  const scrollTop = (event) => {
    event.preventDefault();
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // scrollingElement is the element that actually scrolls in this document, which is not
    // always documentElement (quirks mode puts it on body).
    const scroller = document.scrollingElement || document.documentElement;
    scroller.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
  };

  const init = (root = document) => {
    for (const trigger of root.querySelectorAll('[data-eb-totop]')) {
      if (trigger.dataset.ebTotopReady === 'true') continue;
      trigger.dataset.ebTotopReady = 'true';
      trigger.addEventListener('click', scrollTop);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  // Re-bind after the theme editor re-renders the footer section.
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
